<!--
    Program: BulletinView.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Service Bulletin - Mobile (English) Detail</h2>
            <!-- breadcrumbs -->
            <!-- //breadcrumbs -->
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Date</th>
                        <td>{{view.reg_dt}}</td>
                        <th>Register</th>
                        <td>{{view.reg_user_id}}</td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>{{view.type1}} / {{view.type2}}</td>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th>Urgency</th>
                        <td>
                            <label
                                :class="{ txt_red: view.urgency_yn === 'Y' }"
                                v-if="view.urgency_yn === 'Y'"
                            >Urgent</label>
                            <label v-else>Normal</label>
                        </td>
                        <th>Need Translation</th>
                        <td>
                            <label
                                :class="{ txt_red: view.need_reprocess === 'Y' }"
                            >{{view.need_reprocess}}</label>
                        </td>
                    </tr>
                    <tr>
                        <th>Required Translations</th>
                        <td colspan="3" class="txt_red">{{view.tran}}</td>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td colspan="3">{{view.title}}</td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">{{view.tag_info}}</td>
                        <!-- <th>Sort</th>
                        <td>Move to the top</td>-->
                    </tr>
                    <tr>
                        <th>User Level</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="level in userLevelList"
                                    :key="level.CODE_ID"
                                >{{level.CODE_ID}} ({{level.CODE_NAME}})</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Country / Region</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="country in countryList"
                                    :key="country"
                                >{{country}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Contents</th>
                        <td colspan="3">
                            <span v-html="view.content"></span>
                            <!-- <cross-editor-viewer
                                :editorId="'editorId-'+view.seq"
                                :editorData="view.content || getBlankTemplate"
                            /> -->
                        </td>
                    </tr>
                    <tr>
                        <th>Attachment</th>
                        <td colspan="3" class="no_padding">
                            <innorix-download
                                v-if="fileList.length > 0"
                                :uploadId="uploadId"
                                serviceType="mail"
                                :attachList="fileList"
                                :seq="view.seq"
                            />
                            <span v-else>
                                No Attachment
                            </span>
                            <!-- <div class="attachment_wrap">
                            <img src="images/@attachment.png" alt />
                            </div>-->

                            <dl class="attachment_link" v-if="fileList.length > 0">
                                <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                <dd>
                                <ul>
                                    <li v-for="file in fileList" :key="file.FILE_DIR">
                                        <a href="javascript:" @click="getDownloadUrl(file.ATTCH_FILE_SEQ)" class="txt_link">
                                            <span class="ico_attach"></span> {{ file.FILE_NM }}
                                        </a>
                                    </li>
                                </ul>
                            </dd>
                            </dl>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import CrossEditorViewer from '~c/CrossEditorViewer';
import InnorixDownload from '~c/InnorixDownload';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

export default {
    name: 'hhp-bulletin-view',
    components: {
        'cross-editor-viewer': CrossEditorViewer,
        'innorix-download': InnorixDownload,
    },
    props: {
       	sk : { required: true }
    },
    computed: {
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            roleCd: '',
            view: {},
            countryList: [],
            userLevelList: [],
            fileList: [],
            encToken: '',

            delAttachFiles: [],
            isRemove: false,
            uploadId: 'serviceBulletinMobileViewerDownload',
        };
    },
    created() {
        
        this.init();
    },
    mounted() {
       
    },
    methods: {
        async init() {
            const data = await this.fetchData();
            
            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },

        fetchData() {
        	SDLUtil.showLoadingBar(true);
            return axios
                .post(
                	`${SDLUtil.API_URL}/noauth/serviceBulletin/detail.skp`,
                    qs.stringify({ sk: this.sk }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.push({ path: '/no_auth' });
                });
            
        },

        setData(data) {
            this.roleCd = data.roleCd;

            this.view = data.view;
            this.view.tran = data.view.tran
                .split(',')
                .filter(item => item)
                .map(item => item.replace(/ /g, ''))
                .join(', ');
            // this.view.tran = data.view.tran.replace(',', ''); // replace the first comman.
            this.view.content = SDLUtil.stripHtml(data.view.content);

            this.fileList = data.fileList.rowData;

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            this.userLevelList = data.userLevelList.map(item => {
                const matched = data.userLevelLabelList.find(i => i.CODE_ID === item.USER_LEVEL);
                return {
                    CODE_ID: item.USER_LEVEL,
                    CODE_NAME: matched ? matched.CODE_NAME : '',
                };
            });
            console.log('userLevelList', this.userLevelList);
        },

        // setUserLevelList(list) {},

        // setCountryList(list) {},
        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixDownload.vue -> BulletinView.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
    },
    
    getDownloadUrl(SEQ) {
    	let cmnApiBase = `${SDLUtil.API_URL}/noauth/attachDownload.skp`;
    	return window.open(cmnApiBase + '?attachFileSeq=' + SEQ);
    },
    toggleLink(e) {
        $('.attachment_link > dd').toggle();
    },
};
</script>

<style scoped>
.userlevel_txt {
	float: left;
	width: 220px;
	margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/ServiceBulletinViewer.vue